import {ChangeDetectorRef, Component, Input, OnInit} from '@angular/core';
import {FormGroup} from '@angular/forms';
import {TranslateService} from '@ngx-translate/core';
import {EformAPI} from '../../../e-form.api';
import {Address} from '../../../form-control/properties/address-properties/address-properties.component';
import {EformService} from '../../../service/eform.service';
import { Observable } from 'rxjs';

@Component({
   selector: 'app-address',
   templateUrl: './address.component.html',
   styleUrls: ['./address.component.css']
})
export class AddressComponent implements OnInit {
   @Input() field: any = {};
   @Input() form: FormGroup;
   @Input() checkValidate: any;
   @Input() classes: any;
   @Input() fieldName: any;
   @Input() labelName: any;
   @Input() isFormName: any;
   provinces: Observable<any>;
   districts: Observable<any>;
   subDistricts: Observable<any>;
   countries: Observable<any>;
   loading = false;
   address = {
      province: Address.Province as string,
      district: Address.District as string,
      subDistrict: Address.SubDistrict as string,
      zipCode: Address.ZipCode as string,
      address1: Address.Address1 as string,
      address2: Address.Address2 as string,
      city: Address.City as string,
      state: Address.State as string,
      postal: Address.Postal as string,
      country: Address.Country as string,
      defaultValue: Address.DefaultValue as string,
   };
   lang: string;
   label = {
      province: '',
      district: '',
      subDistrict: '',
      zipCode: '',
      address1: '',
      address2: '',
      city: '',
      state: '',
      postal: '',
      country: '',
      defaultValue: '',
   };
   value: any;

   constructor(private translate: TranslateService, private api: EformAPI, public service: EformService, private cd: ChangeDetectorRef) {
   }

   ngOnInit(): void {
      this.loading = true;
      this.value = this.service.eForm.value.value;
      const fieldName = '-' + this.fieldName;
      this.lang = this.service.selectedLanguage;
      this.address.address1 += fieldName;
      this.address.address2 += fieldName;
      this.field.address1.defaultValue !== undefined ? this.form.controls[this.address.address1].setValue(this.field.address1.defaultValue.value) :
         this.form.controls[this.address.address1].setValue('');
      this.field.address2.defaultValue !== undefined ? this.form.controls[this.address.address2].setValue(this.field.address2.defaultValue.value) :
         this.form.controls[this.address.address2].setValue('');
      if (this.field.type === 'local') {
         this.address.province += fieldName;
         this.address.district += fieldName;
         this.address.subDistrict += fieldName;
         this.address.zipCode += fieldName;
         this.onSetUpProvince();
         if (this.field.province.defaultValue !== undefined && this.field.province.defaultValue.name_th !== '') {
            this.form.controls[this.address.province].setValue(this.field.province.defaultValue.code);
            this.onSetUpDistrict(this.field.province.defaultValue.code, '');
            this.onSetUpSubDistrict(this.field.district.defaultValue.code, '');
         }
         if (this.field.district.defaultValue !== undefined && this.field.district.defaultValue.name_th !== '') {
            this.form.controls[this.address.district].setValue(this.field.district.defaultValue.code);
            this.onSetUpDistrict(this.field.province.defaultValue.code, '');
         }
         if (this.field.subDistrict.defaultValue !== undefined && this.field.subDistrict.defaultValue.name_th !== '') {
            this.form.controls[this.address.subDistrict].setValue(this.field.subDistrict.defaultValue.code);
            this.onSetUpSubDistrict(this.field.district.defaultValue.code, '');
         }
         if (this.field.zipCode.defaultValue !== undefined && this.field.zipCode.defaultValue.name_th !== '') {
            this.form.controls[this.address.zipCode].setValue(this.field.zipCode.defaultValue.zip_code);
         }

         if (this.value){
            this.form.controls[this.address.address1].setValue(this.value[this.address.address1]);
            this.form.controls[this.address.address2].setValue(this.value[this.address.address2]);
            this.form.controls[this.address.province].setValue(this.value[this.address.province]);
            this.onSetUpDistrict(this.value[this.address.province], '');
            this.form.controls[this.address.district].setValue(this.value[this.address.district]);
            this.onSetUpSubDistrict(this.value[this.address.district], '');
            this.form.controls[this.address.subDistrict].setValue(this.value[this.address.subDistrict]);
            this.form.controls[this.address.zipCode].setValue(this.value[this.address.zipCode]);
         }
      } else {
         this.address.city += fieldName;
         this.address.state += fieldName;
         this.address.postal += fieldName;
         this.address.country += fieldName;
         this.field.city.defaultValue !== undefined ? this.form.controls[this.address.city].setValue(this.field.city.defaultValue.value) :
            this.form.controls[this.address.city].setValue('');
         this.field.state.defaultValue !== undefined ? this.form.controls[this.address.state].setValue(this.field.state.defaultValue.value) :
            this.form.controls[this.address.state].setValue('');
         this.field.postal.defaultValue !== undefined ? this.form.controls[this.address.postal].setValue(this.field.postal.defaultValue.value) :
            this.form.controls[this.address.postal].setValue('');
         this.field.country.defaultValue !== undefined ? this.form.controls[this.address.country].setValue(this.field.country.defaultValue.id) :
            this.form.controls[this.address.country].setValue('');
         this.onSetUpCountry();
         if (this.value){
            this.form.controls[this.address.address1].setValue(this.value[this.address.address1]);
            this.form.controls[this.address.address2].setValue(this.value[this.address.address2]);
            this.form.controls[this.address.city].setValue(this.value[this.address.city]);
            this.form.controls[this.address.state].setValue(this.value[this.address.state]);
            this.form.controls[this.address.postal].setValue(this.value[this.address.postal]);
            this.form.controls[this.address.country].setValue(this.value[this.address.country]);
         }
      }
      this.setLabel();
      this.loading = false;
   }

   setLabel() {
      this.label.address1 = this.setLabelAddress(this.field.addressLabel.labelAddress1);
      this.label.address2 = this.setLabelAddress(this.field.addressLabel.labelAddress2);
      this.label.city = this.setLabelAddress(this.field.addressLabel.labelCity);
      this.label.state = this.setLabelAddress(this.field.addressLabel.labelState);
      this.label.postal = this.setLabelAddress(this.field.addressLabel.labelPostal);
      this.label.country = this.setLabelAddress(this.field.addressLabel.labelCountry);
      this.label.province = this.setLabelAddress(this.field.addressLabel.labelProvince);
      this.label.district = this.setLabelAddress(this.field.addressLabel.labelDistrict);
      this.label.subDistrict = this.setLabelAddress(this.field.addressLabel.labelSubDistrict);
      this.label.zipCode = this.setLabelAddress(this.field.addressLabel.labelZipcode);
   }

   setLabelAddress(addressLabel) {
      switch(this.lang) {
         case 'th' :{
            return addressLabel.th;
         }
         case 'cn': {
            return addressLabel.cn;
         }
         default: {
            return addressLabel.en;
         }
      }
   }

   onSetUpCountry() {
      this.countries = this.api.getCountry();
   }

   onSetUpProvince() {
      this.provinces = this.api.getProvince();
   }

   onSetUpDistrict(value: any, state: string) {
      if (state === 'select') {
         this.form.controls[this.address.district].setValue('');
         this.form.controls[this.address.subDistrict].setValue('');
         this.form.controls[this.address.zipCode].setValue('');
      }
      if (value !== undefined && value !== '' && typeof value !== 'boolean') {
         this.districts = this.api.getDistrictWithProvince(value)
      }
   }

   onSetUpSubDistrict(value: any, state: string) {
      if (state === 'select') {
         this.form.controls[this.address.subDistrict].setValue('');
         this.form.controls[this.address.zipCode].setValue('');
      }
      if (value !== undefined && value !== '' && typeof value !== 'boolean') {
         this.subDistricts = this.api.getSubDistrictWithDistrict(value);
      }
   }

   onSetUpZipCode(value: any) {
      if (value !== '') {
         this.api.getZipCodeWithSubDistrict(value).subscribe(res => {
            this.form.controls[this.address.zipCode].setValue(res);
            this.cd.detectChanges();
         });
      } else {
         this.form.controls[this.address.zipCode].setValue('');
      }
   }

   checkSelectCountry(id: any, countryValue: any) {
      return Number(id) === Number(countryValue);
   }

   isEmpty(value: any): boolean {
      return value == null || value === '';
   }
}
